import React from 'react';
import { FooterModel } from '@/types';
import { Box, Link, ResponsiveImage, SocialImage, Stack, Text } from '@/components';
import { useTranslations } from 'next-intl';
import { animControllerInView } from '@/animations';

const Footer = ({ quickLinks, logo, socialLinks, footerLinks }: FooterModel) => {
  const t = useTranslations();

  return (
    <Stack
      animation={animControllerInView({ staggerChildren: 0.1 })}
      tag="footer"
      className="module-base-light flex flex-col overflow-hidden bg-black py-6 lg:py-18"
    >
      <div className="color-from-bg container flex flex-col">
        <div className="flex flex-col lg:flex-row">
          <div className="flex flex-col items-center lg:w-1/4 lg:items-start">
            <Link animate link={{ href: '/' }} className="mb-8 block w-[130px] md:mb-8 lg:mb-4">
              <ResponsiveImage image={logo} />
            </Link>

            <Box className="flex justify-center gap-3 lg:justify-start">
              {socialLinks?.map((link, index) => (
                <Link key={index} link={link} className="py-2">
                  <SocialImage type={link.text} className="h-6 w-6" />
                </Link>
              ))}
            </Box>
          </div>
          <div className="flex flex-col items-center lg:w-1/4 lg:items-start">
            <Text className="text-style-tag pt-3 pb-4 uppercase">{t('footer.$company')}</Text>
            {quickLinks &&
              quickLinks.map((link, index) => (
                <Link
                  animate
                  className="btn !text-style-link !justify-start !py-0 underline pointer-coarse:h-10"
                  key={index}
                  link={link}
                />
              ))}
          </div>
          <div className="color-from-bg flex flex-col items-center lg:w-1/4 lg:items-start">
            <Text className="text-style-tag pt-3 pb-4 uppercase">{t('footer.$legal')}</Text>
            {footerLinks &&
              footerLinks.map((link, index) => (
                <Link
                  animate
                  className="btn !text-style-link !justify-start !py-0 underline pointer-coarse:h-10"
                  key={index}
                  link={link}
                />
              ))}
          </div>
          <div className="color-from-bg flex flex-col items-center lg:w-1/4 lg:items-start">
            <Text className="text-style-tag pt-3 pb-4 uppercase">{t('footer.$subscribe')}</Text>
            <Text className="text-style-link">
              {t.rich('footer.$signUp', {
                link: (chunks) => (
                  <Link className="cursor-pointer underline" link={{ href: '/newsletter-sign-up' }}>
                    {chunks}
                  </Link>
                ),
              })}
            </Text>
          </div>
        </div>
        <div className="mt-10 flex justify-end border-t border-white pt-10">
          <p className="text-style-link">{t('footer.$copyright')}</p>
        </div>
      </div>
    </Stack>
  );
  /*
  return (
    <Stack
      animation={animControllerInView({ staggerChildren: 0.1 })}
      tag="footer"
      className="module-base-light flex flex-col overflow-hidden bg-[#262626] pt-16 pb-8 lg:py-0"
    >
      {quickLinks && quickLinks.length > 0 && (
        <>
          <div className="color-from-bg order-3 container lg:hidden">
            <Text className="pt-10 pb-10 text-lg leading-[22px] font-bold">{t('footer.$quickLinks')}</Text>
          </div>
          <div className="color-from-bg order-4 container flex flex-col justify-between lg:order-1 lg:flex-row lg:py-9">
            {quickLinks.map((link, index) => (
              <Link animate className="btn !justify-start underline pointer-coarse:h-10" key={index} link={link} />
            ))}
          </div>
          <div className="order-2 px-4 lg:order-2">
            <div className="h-px w-full bg-white/10"></div>
          </div>
        </>
      )}
      <div className="color-from-bg order-1 container flex flex-col gap-8 py-6 lg:order-3 lg:flex-row lg:gap-4 lg:py-12">
        <div className="flex w-full flex-col items-center lg:w-1/4 lg:items-start">
          <Link animate link={{ href: '/' }} className="mb-8 block w-[130px] md:mb-8 lg:mb-4">
            <ResponsiveImage image={logo} />
          </Link>
          <Text className="pt-3 pb-4 text-lg leading-[22px] font-bold">{t('footer.$followUs')}</Text>
          <Box className="flex gap-3">
            {socialLinks?.map((link, index) => (
              <Link key={index} link={link} className="py-2">
                <SocialImage type={link.text} className="h-6 w-6" />
              </Link>
            ))}
          </Box>
        </div>
        <div className="flex w-full flex-col items-center lg:w-2/4 lg:items-start">
          <Text className="pb-10 text-lg leading-[22px] font-bold">{t('footer.$findUs')}</Text>
          <div className="flex w-full flex-row gap-4 font-medium [&_p]:pb-4">
            <Box className="body-1 w-1/2 text-center lg:text-left" dangerouslySetInnerHTML={{ __html: address }} />
            <Box
              className="body-1 w-1/2 text-center lg:text-left"
              dangerouslySetInnerHTML={{ __html: secondAddress }}
            />
          </div>
        </div>
        <div className="w-full lg:w-1/4">
          <Text className="pb-9 text-center text-lg leading-[22px] font-bold lg:text-left">{t('footer.$contact')}</Text>
          <Box
            className={classNames(
              'body-1 w-full pl-6 text-center font-medium lg:text-left [&_.cd]:pb-3',
              '[&_.mail]:relative [&_.mail]:before:absolute [&_.mail]:before:-left-7 [&_.mail]:before:h-6 [&_.mail]:before:w-6 [&_.mail]:before:bg-[url("../assets/envelopeSimpleLight.svg")] [&_.mail]:before:bg-contain [&_.mail]:before:opacity-50 [&_.mail]:before:invert',
              '[&_.phone]:relative [&_.phone]:before:absolute [&_.phone]:before:-top-1 [&_.phone]:before:-left-7 [&_.phone]:before:h-6 [&_.phone]:before:w-6 [&_.phone]:before:bg-[url("../assets/deviceMobileLight.svg")] [&_.phone]:before:bg-contain [&_.phone]:before:opacity-50 [&_.phone]:before:invert',
            )}
            dangerouslySetInnerHTML={{ __html: contact }}
          />
        </div>
      </div>
      {footerLinks && (
        <>
          <div className="hidden px-4 lg:order-4 lg:block">
            <div className="h-px w-full bg-white/10"></div>
          </div>
          <div className="color-from-bg order-5 container flex flex-col justify-between lg:flex-row lg:py-9">
            {footerLinks.map((link, index) => (
              <Link animate className="btn !justify-start underline pointer-coarse:h-10" key={index} link={link} />
            ))}
          </div>
        </>
      )}
    </Stack>
  );
  */
};

export default Footer;
